console.log("member-pages loaded");
















class Customer {
  constructor(firstName, lastName, gender, phoneNumber, email, birthDay, interestInProducts, lineId) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.gender = gender;
    this.phoneNumber = phoneNumber;
    this.email = email;
    this.birthDay = birthDay;
    this.interestInProducts = interestInProducts;
    this.lineId = lineId;
  }
}

async function VTECAuthorizationToken() {
  const storedToken = sessionStorage.getItem("btvCurrentCustomerToken");
  if (storedToken) {
    return storedToken;
  }

  const response = await fetch("https://pos.vvretail.co.th/retailplatform/api/MerchantInfo/authenticate", {
    method: "POST",
    body: JSON.stringify({
      Username: "mobileUser",
      Password: "mB1975VTEC"
    }),
    headers: {
      "Content-type": "application/json"
    }
  });

  const data = await response.json();
  sessionStorage.setItem("btvCurrentCustomerToken", data.token);
  return data.token;
}

async function VTECRequestUUID() {
  try {
    const storedUUID = sessionStorage.getItem("btvCurrentCustomerUUID");
    if (storedUUID) {
      return storedUUID;
    }

    const token = await VTECAuthorizationToken();
    const UUID = generateUUID();
    const params = new URLSearchParams({
      reqId: UUID,
      WebUrl: "9311-3283-4881-3260"
    });
    const url = "https://pos.vvretail.co.th/retailplatform/api/MerchantInfo/MerchantInfo" + `?${params.toString()}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        "Authorization": "Bearer " + token
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    if (data.responseText == 'SUCCESS') {
      sessionStorage.setItem("btvCurrentCustomerUUID", UUID);
      return UUID;
    } else {
      throw new Error("Invalid response data");
    }
  } catch (error) {
    console.error("Error during VTECRequestUUID:", error);
    throw error;
  }
}

// DEPRECATED
async function VTECPropertyData() {
  const token = await VTECAuthorizationToken();
  const UUID = await VTECRequestUUID();
  const params = new URLSearchParams({ reqId: UUID });
  const url = "https://pos.vvretail.co.th/retailplatform/api/POSModule/PropertyData" + `?${params.toString()}`;

  fetch(url, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
      "Authorization": "Bearer " + token
    }
  });
}

async function VTECCheckRegisteredByUserPhone(phoneNumber) {
  const token = await VTECAuthorizationToken();
  const UUID = await VTECRequestUUID();
  const params = new URLSearchParams({ reqId: UUID, mobileNo: phoneNumber, langId: 1, brandcode: "BTV" });
  const url = "https://pos.vvretail.co.th/retailplatform/api/CRMInterfaceBV/Member_Data" + `?${params.toString()}`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
      "Authorization": "Bearer " + token
    }
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const data = await response.json();

  if(data['responseText'] == 'Cannot find member profile.') {
    return undefined;
  } else if(data['loyaltyObj']['memberInfo']['lineID'] == null || data['loyaltyObj']['memberInfo']['lineID'] == undefined || data['loyaltyObj']['memberInfo']['lineID'] == '') {
    SaveMemberDetails(data['loyaltyObj']['memberInfo']);
    SaveMemberOpticAttributes(data['responseObj']);
    SaveMemberDiscount(data['promotions']);
    return false;
  } else {
    SaveMemberDetails(data['loyaltyObj']['memberInfo']);
    SaveMemberOpticAttributes(data['responseObj']);
    SaveMemberDiscount(data['promotions']);
    return true;
  }
}

async function VTECRegisterNewMember(input) {
  const token = await VTECAuthorizationToken();
  const UUID = await VTECRequestUUID();
  const params = new URLSearchParams({ reqId: UUID, isNewMember: true });
  const url = "https://pos.vvretail.co.th/retailplatform/api/CRMInterfaceBV/Member_Register" + `?${params.toString()}`;
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify({
      brandcode: "BTV",
      shopCode: input.shopCode,
      memberTitle: "",
      memberFirstName: input.firstName,
      memberLastName: input.lastName,
      memberGenderID: input.gender,
      memberMobile: input.phoneNumber,
      lineId: input.lineId,
      memberEmail: input.email,
      memberBirthDay: input.birthDay,
      extraParam1: input.extraParam1
    }),
    headers: {
      "Content-type": "application/json",
      "Authorization": "Bearer " + token
    }
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const data = await response.json();
  return data;
}

async function authorizationToken() {
  const response = await fetch("https://apis.btv.co.th/api/token", {
    method: "POST",
    body: JSON.stringify({
      Username: "shopifyapi",
      Password: "E84E64F1-90F4-4448-BCB3-F249A7CFAA7F"
    }),
    headers: {
      "Content-type": "application/json"
    }
  });

  const data = await response.json();
  return data.token; // Assuming your authorization response has a 'token' property
}

async function customerPhoneInput(phoneNumber) {
  const result = await VTECCheckRegisteredByUserPhone(phoneNumber);

  if (result == undefined) {
    notFoundCustomer();
  } else if (result == true) {
    // fetchUserDetailByPhone
    redirectToCustomerDetails();
  } else {
    redirectToFoundCustomer();
  }
}

async function saveLineID(lineID) {
  const token = await VTECAuthorizationToken();
  const UUID = await VTECRequestUUID();
  const params = new URLSearchParams({ reqId: UUID });
  const url = "https://pos.vvretail.co.th/retailplatform/api/CRMInterfaceBV/Member_Edit" + `?${params.toString()}`;
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify({
      brandcode: "BTV",
      memberID: sessionStorage.getItem('btvActualCustomerId'),
      lineId: lineID
    }),
    headers: {
      "Content-type": "application/json",
      "Authorization": "Bearer " + token
    }
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const data = await response.json();
  console.log(data);
}

// DEPRECATED
async function customerDetails(phoneNumber, birthday, id) {
  try {
    const token = await authorizationToken();
    let queryParams = "phone_number=" + phoneNumber;

    if (id) {
      queryParams += "&vipid=" + id;
    } else if (birthday) {
      queryParams += "&birthday=" + birthday;
    }

    const response = await fetch("https://apis.btv.co.th/api/customers?" + queryParams, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token,
      },
    });

    if (response.ok) {
      const customerData = await response.json();
      if (customerData.user.vipid != null && customerData.user.vipid != undefined) {
        sessionStorage.setItem("btvCurrentCustomerId", customerData.user.vipid);
        sessionStorage.setItem("btvCurrentCustomerFirstName", customerData.user.firstname);
        sessionStorage.setItem("btvCurrentCustomerLastName", customerData.user.lastname);
        sessionStorage.setItem("btvCurrentCustomerGender", customerData.user.gender);
        sessionStorage.setItem("btvCurrentCustomerPhoneNumber", customerData.user.phone_number);
        sessionStorage.setItem("btvCurrentCustomerEmail", customerData.user.email);
        sessionStorage.setItem("btvCurrentCustomerBirthDay", customerData.user.birthday);
        sessionStorage.setItem("btvCurrentCustomerInterestInProducts", customerData.user.interested_product);
        sessionStorage.setItem("btvCurrentCustomerLineId", customerData.user.line_id);
        sessionStorage.setItem("btvCurrentCustomerMemberTier", customerData.user.member_tier);
        sessionStorage.setItem("btvCurrentCustomerMemberPoint", customerData.user.member_point);

        if (customerData.user.line_id != null && customerData.user.line_id != undefined && customerData.user.line_id !== '') {
          redirectToThankYou();
        } else {
          redirectToLine();
        }
      } else {
        notFoundCustomer();
      }
    } else {
      notFoundCustomer();
    }
  } catch (error) {
    console.error("An error occurred:", error);
    notFoundCustomer();
  }
}

function SaveMemberDetails(data) {
  sessionStorage.setItem("btvCurrentCustomerId", data['memberCode']);
  sessionStorage.setItem("btvActualCustomerId", data['memberID']);
  sessionStorage.setItem("btvCurrentCustomerFirstName", data['memberFirstName']);
  sessionStorage.setItem("btvCurrentCustomerLastName", data['memberLastName']);
  sessionStorage.setItem("btvCurrentCustomerGender", data['memberGenderID']);
  sessionStorage.setItem("btvCurrentCustomerPhoneNumber", data['memberMobile']);
  sessionStorage.setItem("btvCurrentCustomerEmail", data['memberEmail']);
  sessionStorage.setItem("btvCurrentCustomerBirthDay", data['memberBirthDay']);
  sessionStorage.setItem("btvCurrentCustomerPoint", data['memberPoints']);
  sessionStorage.setItem("btvCurrentCustomerMemberTier", data['memberGroupName']);

  if (data['lineID'] != null && data['lineID'] != undefined && data['lineID'] != '') {
    sessionStorage.setItem("btvCurrentCustomerLineId", data['lineID']);
  }
}

function SaveMemberOpticAttributes(data) {
  const rightEyeData = data.find(item => item.oculusTypeCode === "R");
  const leftEyeData = data.find(item => item.oculusTypeCode === "L");

  if (!rightEyeData && !leftEyeData) {
    return;
  }

  if (rightEyeData) {
    sessionStorage.setItem("btvCurrentCustomerOpticSPHRight", rightEyeData['sph']);
    sessionStorage.setItem("btvCurrentCustomerOpticCYLRight", rightEyeData['cyl']);
    sessionStorage.setItem("btvCurrentCustomerOpticAxisRight", rightEyeData['axis']);
  }

  if (leftEyeData) {
    sessionStorage.setItem("btvCurrentCustomerOpticSPHLeft", leftEyeData['sph']);
    sessionStorage.setItem("btvCurrentCustomerOpticCYLLeft", leftEyeData['cyl']);
    sessionStorage.setItem("btvCurrentCustomerOpticAxisLeft", leftEyeData['axis']);
  }

  sessionStorage.setItem("btvCurrentCustomerOpticUpdatedAt", data[0]['updateDate']);
}


function SaveMemberDiscount(data) {
  const tierPromotionData = data.find(item => item.promotionCode === sessionStorage.getItem("btvCurrentCustomerMemberTier"));

  if (tierPromotionData) {
    sessionStorage.setItem("btvCurrentCustomerMemberDiscount", tierPromotionData['percentDiscount']);
  }
}

function ClearSession() {
  const keys = [
    "btvCurrentCustomerId",
    "btvActualCustomerId",
    "btvCurrentCustomerFirstName",
    "btvCurrentCustomerLastName",
    "btvCurrentCustomerGender",
    "btvCurrentCustomerPhoneNumber",
    "btvCurrentCustomerEmail",
    "btvCurrentCustomerBirthDay",
    "btvCurrentCustomerPoint",
    "btvCurrentCustomerInterestInProducts",
    "btvCurrentCustomerMemberTier",
    "btvCurrentCustomerLineId",
    "btvCurrentCustomerOpticSPHRight",
    "btvCurrentCustomerOpticCYLRight",
    "btvCurrentCustomerOpticAxisRight",
    "btvCurrentCustomerOpticSPHLeft",
    "btvCurrentCustomerOpticCYLLeft",
    "btvCurrentCustomerOpticAxisLeft",
    "btvCurrentCustomerOpticUpdatedAt",
    "btvCurrentCustomerMemberDiscount",
    "btvCurrentCustomerMemberPoint"
  ];

  keys.forEach(key => sessionStorage.removeItem(key));
}

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function redirectToLine(branchId = '') {
  window.location.href = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1654101732&state=btv11234&scope=profile%20openid%20email&redirect_uri=https://asia-southeast1-btv-line-login.cloudfunctions.net/line-login-callback?branchId=${branchId}`;
}

function isConnectToLine(customer) {
  return(typeof customer.lineId !== 'undefined');
}

function clearInvalid() {
  document.querySelectorAll('.member-input').forEach(i => (
      i.classList.remove('invalid')
  ));
  document.querySelectorAll('.member-error').forEach(i => (
      i.style.display = 'none'
  ));
}

function redirectToThankYou() {
  window.location.href = "/pages/member-thank-you"
}

function redirectToCustomerDetails() {
  window.location.href = "/pages/member-customer-profile"
}

function redirectToFoundCustomer() {
  window.location.href = "/pages/member-found-customer"
}

function convertBuddhistToGregorian(dateString) {
  const dateParts = dateString.split('-');
  let year = parseInt(dateParts[0], 10);
  const month = parseInt(dateParts[1], 10) - 1; // Months are 0-based in JS
  const day = parseInt(dateParts[2], 10);

  // Convert Buddhist Era year to Gregorian year if necessary
  if (year > 2400) {
      year -= 543;
  }

  return new Date(year, month, day);
}

// Function to parse date in "2 Jun 1992" format
function parseCustomDate(dateString) {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const dateParts = dateString.split(' ');
  const day = parseInt(dateParts[0], 10);
  const month = months.indexOf(dateParts[1]);
  const year = parseInt(dateParts[2], 10);

  return new Date(year, month, day);
}

function formattedBirthDayDate(dateString) {
  if (dateString === null || dateString === undefined || dateString === '') {
    return '';
  }

  const dateObject = new Date(dateString);

  if (isNaN(dateObject.getTime())) {
      dateObject = convertBuddhistToGregorian(dateString);
  }

  if (isNaN(dateObject.getTime())) {
      dateObject = parseCustomDate(dateString);
  }

  if (!isNaN(dateObject)) {
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so we add 1
    const day = String(dateObject.getDate()).padStart(2, '0');

    return(`${year}-${month}-${day}`);
  } else {
    return "";
  }
}

function scrollUp() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}
